"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextField = exports.Select = exports.RangeField = exports.Radios = exports.PhoneNumber = exports.MultiImageUploader = exports.MultiDatePicker = exports.LocationPicker = exports.ImageUploaderEditable = exports.ImageUploader = exports.Checkbox = exports.ButtonImageUploaderEditable = exports.ButtonImageUploader = exports.Autocomplete = exports.AddressAutocomplete = void 0;
var _reactRedux = require("react-redux");
var _core = require("@material-ui/core");
var _Autocomplete = _interopRequireDefault(require("@material-ui/lab/Autocomplete"));
var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));
var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));
var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));
var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));
var _FormHelperText = _interopRequireDefault(require("@material-ui/core/FormHelperText"));
var _FormLabel = _interopRequireDefault(require("@material-ui/core/FormLabel"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));
var _InputLabel = _interopRequireDefault(require("@material-ui/core/InputLabel"));
var _OutlinedInput = _interopRequireDefault(require("@material-ui/core/OutlinedInput"));
var _Radio = _interopRequireDefault(require("@material-ui/core/Radio"));
var _RadioGroup = _interopRequireDefault(require("@material-ui/core/RadioGroup"));
var _Select = _interopRequireDefault(require("@material-ui/core/Select"));
var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));
var _InsertInvitation = _interopRequireDefault(require("@material-ui/icons/InsertInvitation"));
var _formik = require("formik");
var _lodash = _interopRequireDefault(require("lodash"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _reactMultipleDatepicker = _interopRequireDefault(require("react-multiple-datepicker"));
var _reactPlacesAutocomplete = _interopRequireWildcard(require("react-places-autocomplete"));
var _index = _interopRequireDefault(require("@date-io/date-fns/build/index"));
var _pickers = require("@material-ui/pickers");
var _styles = require("@material-ui/core/styles");
var _moment = _interopRequireDefault(require("moment"));
var _Translations = require("../Translations");
var _ButtonImageUploader = _interopRequireDefault(require("../uploader/ButtonImageUploader"));
var _ImageUploader = _interopRequireDefault(require("../uploader/ImageUploader"));
var _MultiImageUploder = _interopRequireDefault(require("../uploader/MultiImageUploder"));
var _PhoneNumberInput = _interopRequireDefault(require("../PhoneNumberInput"));
var _ButtonImageUploaderEditable = _interopRequireDefault(require("../uploader/ButtonImageUploaderEditable"));
var _ImageUploaderEditable = _interopRequireDefault(require("../uploader/ImageUploaderEditable"));
var _PhoneNumber = require("./PhoneNumber");
var _LocationPicker = require("./LocationPicker");
var _RangeField = require("./RangeField/RangeField");
var _formValidators = require("../form-validators");
var _enUS = _interopRequireDefault(require("date-fns/locale/en-US"));
var _fr = _interopRequireDefault(require("date-fns/locale/fr"));
var _es = _interopRequireDefault(require("date-fns/locale/es"));
var _de = _interopRequireDefault(require("date-fns/locale/de"));
var _excluded = ["field", "form"],
  _excluded2 = ["field", "form"],
  _excluded3 = ["field", "form"],
  _excluded4 = ["field", "form"],
  _excluded5 = ["field", "form"],
  _excluded6 = ["field", "form"],
  _excluded7 = ["field", "form"],
  _excluded8 = ["field", "form"],
  _excluded9 = ["field", "form"],
  _excluded10 = ["label", "loading"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var datePickerLocales = {
  en: _enUS.default,
  fr: _fr.default,
  es: _es.default,
  de: _de.default
};

// Create text field component from Material UI TextField
var TextFieldComponent = function TextFieldComponent(_ref) {
  var field = _ref.field,
    form = _ref.form,
    props = _objectWithoutProperties(_ref, _excluded);
  var labelRef = /*#__PURE__*/_react.default.createRef();
  var _useSelector = (0, _reactRedux.useSelector)(function (_ref2) {
      var localeReducer = _ref2.localeReducer;
      return {
        locale: localeReducer.locale
      };
    }),
    locale = _useSelector.locale;
  var meta = form.getFieldMeta(field.name);
  var hasError = Boolean(meta.touched && (meta.error || !_lodash.default.isEmpty(meta.error)));
  if (props.type === 'date') {
    var datepickerOutlinedInputProps = ['autoFocus', 'classes', 'color', 'defaultValue', 'disabled', 'error', 'fullWidth', 'id', 'inputRef', 'margin', 'format', 'name', 'onChange', 'required', 'value', 'size', 'className', 'style', 'openTo', 'minDate', 'maxDate'];
    var fieldValue = field.value;
    var hasTheRightFormat = (0, _moment.default)(fieldValue, "YYYY-MM-DD", true).isValid();
    if (fieldValue && !hasTheRightFormat) {
      fieldValue = (0, _moment.default)(fieldValue, "DD-MM-YYYY").format("YYYY-MM-DD");
    }
    return /*#__PURE__*/_react.default.createElement(_pickers.MuiPickersUtilsProvider, {
      utils: _index.default,
      locale: _lodash.default.has(datePickerLocales, locale) ? datePickerLocales[locale] : datePickerLocales['en']
    }, /*#__PURE__*/_react.default.createElement(_pickers.DatePicker, _extends({
      autoOk: true,
      animateYearScrolling: true,
      cancelLabel: false,
      okLabel: false,
      openTo: "date",
      views: ['year', 'month', 'date'],
      invalidDateMessage: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: "Invalid date format",
        defaultMessage: "Invalid date format"
      }),
      maxDateMessage: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: "Date should not be after maximal date",
        defaultMessage: "Date should not be after maximal date"
      }),
      minDateMessage: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: "Date should not be before minimal date",
        defaultMessage: "Date should not be before minimal date"
      }),
      id: field.name,
      "aria-describedby": field.name,
      format: "dd/MM/yyyy",
      KeyboardButtonProps: {
        'aria-label': 'change date'
      },
      inputVariant: "outlined",
      error: hasError,
      label: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: props.label
      }),
      placeholder: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: props.placeholder
      })
    }, field, {
      onChange: function onChange(date) {
        return form.setFieldValue(field.name, (0, _moment.default)(date).format('YYYY-MM-DD'));
      }
    }, _lodash.default.pick(props, datepickerOutlinedInputProps), {
      value: fieldValue || null
    }, hasError ? {
      helperText: meta.error
    } : null)));
  }
  var outlinedInputProps = ['autoComplete', 'autoFocus', 'classes', 'color', 'defaultValue', 'disabled', 'endAdornment', 'error', 'fullWidth', 'id', 'inputComponent', 'inputProps', 'inputRef', 'label', 'labelWidth', 'margin', 'multiline', 'name', 'notched', 'onChange', 'placeholder', 'readOnly', 'required', 'rows', 'rowsMax', 'startAdornment', 'type', 'value', 'size', 'className', 'style'];
  var formControlProps = _lodash.default.pick(props, ['classes', 'color', 'disabled', 'fullWidth', 'margin', 'required', 'size', 'variant', 'children', 'component']);
  var inputLabelProps = _lodash.default.get(props, ['InputLabelProps']);
  var translatedLabel = /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: props.label,
    defaultMessage: props.label
  });
  return /*#__PURE__*/_react.default.createElement(_FormControl.default, _extends({
    variant: "outlined"
  }, formControlProps, {
    error: hasError
  }), /*#__PURE__*/_react.default.createElement(_InputLabel.default, _extends({}, inputLabelProps, {
    htmlFor: field.name,
    ref: labelRef
  }), translatedLabel), /*#__PURE__*/_react.default.createElement(_OutlinedInput.default, _extends({
    error: hasError,
    id: field.name,
    "aria-describedby": field.name
  }, field, _lodash.default.pick(props, outlinedInputProps), {
    label: translatedLabel
  })), hasError && /*#__PURE__*/_react.default.createElement(_FormHelperText.default, {
    id: field.name
  }, meta.error));
};
// Create formik field using the text field component and pass props to it
var TextField = function TextField(props) {
  return /*#__PURE__*/_react.default.createElement(_formik.Field, _extends({
    component: TextFieldComponent
  }, props));
};

// Create checkbox component from Material UI Checkbox
exports.TextField = TextField;
var CheckboxComponent = function CheckboxComponent(_ref3) {
  var field = _ref3.field,
    form = _ref3.form,
    props = _objectWithoutProperties(_ref3, _excluded2);
  var meta = form.getFieldMeta(field.name);
  // Handle error state of the component
  var hasError = Boolean(meta.touched && (meta.error || !_lodash.default.isEmpty(meta.error)));
  var formControlProps = _lodash.default.pick(props, ['classes', 'color', 'disabled', 'fullWidth', 'margin', 'required', 'size', 'variant', 'children', 'component']);
  var checkboxProps = _lodash.default.pick(props, ['onChange']);
  return /*#__PURE__*/_react.default.createElement(_FormControl.default, _extends({
    error: hasError
  }, formControlProps), /*#__PURE__*/_react.default.createElement(_FormControlLabel.default
  // Pass label in get text
  , _extends({
    label: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: props.label
    }),
    control: /*#__PURE__*/_react.default.createElement(_Checkbox.default, _extends({
      checked: field.value,
      color: "primary",
      name: field.name,
      id: field.name
    }, checkboxProps))
  }, field)), hasError && /*#__PURE__*/_react.default.createElement(_FormHelperText.default, null, meta.error));
};
// Create formik field using the checkbox component and pass props to it
var Checkbox = function Checkbox(props) {
  return /*#__PURE__*/_react.default.createElement(_formik.Field, _extends({
    component: CheckboxComponent
  }, props));
};
exports.Checkbox = Checkbox;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    menuList: {
      position: 'relative',
      maxHeight: 'calc(100vh - 200px)'
    },
    container: {
      position: 'sticky',
      bottom: '0px'
    },
    wrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '1rem 1.5rem',
      backgroundColor: '#fff'
    },
    selectInput: {
      whiteSpace: 'pre-wrap'
    }
  };
});
// Create select component from Material UI Select
var SelectComponent = function SelectComponent(_ref4) {
  var field = _ref4.field,
    form = _ref4.form,
    props = _objectWithoutProperties(_ref4, _excluded3);
  var classes = useStyles();
  var labelRef = /*#__PURE__*/_react.default.createRef();
  var meta = form.getFieldMeta(field.name);
  // Handle error state of the component
  var hasError = Boolean(meta.touched && !_lodash.default.isEmpty(meta.error));
  var formControlProps = _lodash.default.pick(props, ['classes', 'color', 'disabled', 'fullWidth', 'margin', 'required', 'size', 'variant', 'children', 'component']);
  var selectProps = _lodash.default.pick(props, ['name', 'value', 'onChange', 'input', 'multiple', 'onClose', 'native', 'renderValue']);
  var inputProps = _lodash.default.pick(props, ['endAdornment']);
  // Pass label in get text
  var label = /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: props.label
  });

  // handle multi select case (we are use [] insteadof undifined)
  if (selectProps.multiple) {
    field.value = Array.isArray(field.value) ? field.value : [];
  }
  return /*#__PURE__*/_react.default.createElement(_FormControl.default, _extends({
    error: hasError
  }, formControlProps), /*#__PURE__*/_react.default.createElement(_InputLabel.default, {
    ref: labelRef,
    htmlFor: props.name
  }, label), /*#__PURE__*/_react.default.createElement(_Select.default, _extends({
    error: hasError,
    input: /*#__PURE__*/_react.default.createElement(_OutlinedInput.default, _extends({
      inputProps: {
        className: classes.selectInput
      },
      labelWidth: label.props.id.length * 8,
      name: props.label,
      id: props.name
    }, inputProps)),
    MenuProps: {
      MenuListProps: {
        className: classes.menuList
      }
    }
  }, field, selectProps), props.children, selectProps.multiple && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.wrapper,
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    onClick: function onClick() {
      form.setFieldValue(field.name, []);
    },
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Effacer",
    defaultMessage: "Effacer"
  })), /*#__PURE__*/_react.default.createElement(_core.Button, {
    onClick: function onClick() {
      document.getElementById("menu-".concat(field.name)).firstChild.click();
    },
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Valider",
    defaultMessage: "Valider"
  }))))), hasError && /*#__PURE__*/_react.default.createElement(_FormHelperText.default, null, meta.error));
};

// Create formik field using the select component and pass props to it
var Select = function Select(props) {
  return /*#__PURE__*/_react.default.createElement(_formik.Field, _extends({
    component: SelectComponent
  }, props));
};

// We use this compoent to select multi date (is not range date picker)
exports.Select = Select;
var MultiDatePickerComponent = function MultiDatePickerComponent(_ref5) {
  var field = _ref5.field,
    form = _ref5.form,
    props = _objectWithoutProperties(_ref5, _excluded4);
  var InputDatePicker = function InputDatePicker(_ref6) {
    var field = _ref6.field,
      form = _ref6.form,
      props = _objectWithoutProperties(_ref6, _excluded5);
    var labelRef = /*#__PURE__*/_react.default.createRef();
    var meta = form.getFieldMeta(field.name);
    var hasError = Boolean(meta.touched && !_lodash.default.isEmpty(meta.error));
    var value = props.value,
      onChange = props.onChange,
      onClick = props.onClick;
    var label = /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: props.label
    });
    return /*#__PURE__*/_react.default.createElement(_FormControl.default, {
      variant: "outlined",
      fullWidth: true,
      margin: "normal",
      onClick: onClick
    }, /*#__PURE__*/_react.default.createElement(_InputLabel.default, {
      ref: labelRef,
      htmlFor: props.name
    }, label), /*#__PURE__*/_react.default.createElement(_OutlinedInput.default, {
      id: "outlined-adornment-password",
      type: 'text',
      onChange: onChange,
      value: value,
      fullWidth: true,
      readOnly: true,
      endAdornment: /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
        position: "end"
      }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
        "aria-label": "toggle password visibility",
        onClick: onClick,
        edge: "end"
      }, /*#__PURE__*/_react.default.createElement(_InsertInvitation.default, null))),
      labelWidth: 70
    }));
  };
  return /*#__PURE__*/_react.default.createElement(_reactMultipleDatepicker.default, {
    onSubmit: function onSubmit(dates) {
      return props.onChange(dates);
    }
  }, /*#__PURE__*/_react.default.createElement(InputDatePicker, _extends({
    form: form,
    field: field
  }, props)));
};
var MultiDatePicker = function MultiDatePicker(props) {
  return /*#__PURE__*/_react.default.createElement(_formik.Field, _extends({
    component: MultiDatePickerComponent
  }, props));
};
exports.MultiDatePicker = MultiDatePicker;
var ImageUploader = function ImageUploader(props) {
  return /*#__PURE__*/_react.default.createElement(_formik.Field, _extends({
    component: _ImageUploader.default
  }, props));
};
exports.ImageUploader = ImageUploader;
var ButtonImageUploader = function ButtonImageUploader(props) {
  return /*#__PURE__*/_react.default.createElement(_formik.Field, _extends({
    component: _ButtonImageUploader.default
  }, props));
};
exports.ButtonImageUploader = ButtonImageUploader;
var MultiImageUploader = function MultiImageUploader(props) {
  return /*#__PURE__*/_react.default.createElement(_formik.Field, _extends({
    component: _MultiImageUploder.default
  }, props));
};
exports.MultiImageUploader = MultiImageUploader;
var ButtonImageUploaderEditable = function ButtonImageUploaderEditable(props) {
  return /*#__PURE__*/_react.default.createElement(_formik.Field, _extends({
    component: _ButtonImageUploaderEditable.default
  }, props));
};
exports.ButtonImageUploaderEditable = ButtonImageUploaderEditable;
var ImageUploaderEditable = function ImageUploaderEditable(props) {
  return /*#__PURE__*/_react.default.createElement(_formik.Field, _extends({
    component: _ImageUploaderEditable.default
  }, props));
};
exports.ImageUploaderEditable = ImageUploaderEditable;
var RadiosComponent = function RadiosComponent(_ref7) {
  var field = _ref7.field,
    form = _ref7.form,
    props = _objectWithoutProperties(_ref7, _excluded6);
  var meta = form.getFieldMeta(field.name);
  var hasError = Boolean(meta.touched && (meta.error || !_lodash.default.isEmpty(meta.error)));
  var formControlProps = _lodash.default.pick(props, ['classes', 'color', 'disabled', 'fullWidth', 'margin', 'required', 'size', 'variant', 'children', 'component']);
  return /*#__PURE__*/_react.default.createElement(_FormControl.default, _extends({
    error: hasError
  }, formControlProps), /*#__PURE__*/_react.default.createElement(_FormLabel.default, {
    component: "legend"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: props.label
  })), props.extraTextLabel && props.extraTextLabel, /*#__PURE__*/_react.default.createElement(_RadioGroup.default, {
    row: true,
    "aria-label": field.name,
    name: field.name,
    defaultValue: field.value
  }, props.choices && props.choices.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, {
      key: index,
      value: item.value,
      control: /*#__PURE__*/_react.default.createElement(_Radio.default, {
        color: "primary"
      }),
      label: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: item.label
      }),
      labelPlacement: item.labelPlacement || 'start',
      onChange: field.onChange
    });
  })));
};
var Radios = function Radios(props) {
  return /*#__PURE__*/_react.default.createElement(_formik.Field, _extends({
    component: RadiosComponent
  }, props));
};
exports.Radios = Radios;
var AddressAutocompleteComponent = function AddressAutocompleteComponent(_ref8) {
  var field = _ref8.field,
    form = _ref8.form,
    props = _objectWithoutProperties(_ref8, _excluded7);
  var _useState = (0, _react.useState)(props.isForced),
    _useState2 = _slicedToArray(_useState, 2),
    showError = _useState2[0],
    setShowError = _useState2[1];
  var _timeout = 0;
  var updateAddress = function updateAddress(searchTerm) {
    _timeout && clearTimeout(_timeout);
    _timeout = setTimeout(function () {
      (0, _reactPlacesAutocomplete.geocodeByAddress)(searchTerm).then(function (result) {
        if (result[0]) {
          form.setFieldValue('address-latitude', result[0].geometry.location.lat());
          form.setFieldValue('address-longitude', result[0].geometry.location.lng());
        }
      });
    }, props.time ? props.time : 2000);
  };
  if (form.isValidating && form.isSubmitting && (!form.values['address-latitude'] || !form.values['address-longitude'])) {
    form.setFieldError('address-address_01', /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: "Select one of the suggestions that appear when typing"
    }));
    form.setSubmitting(false);
  }
  return /*#__PURE__*/_react.default.createElement(_reactPlacesAutocomplete.default, {
    searchOptions: props.searchOptions,
    value: field.value,
    onChange: function onChange(searchTerm) {
      if (!showError && props.isForced) setShowError(true);
      form.setFieldValue(field.name, searchTerm);
      form.setFieldValue(props.latitude ? props.latitude : 'address-latitude', '');
      form.setFieldValue(props.longitude ? props.longitude : 'address-longitude', '');
      // searchTerm && props.updateAfterTyping && updateAddress(searchTerm)
    },

    onSelect: function onSelect(result) {
      setShowError(false);
      form.setFieldValue(field.name, result);
      (0, _reactPlacesAutocomplete.geocodeByAddress)(result).then(function (result) {
        var _result;
        var address = ((_result = result[result.length - 1]) === null || _result === void 0 ? void 0 : _result.address_components) || [];
        var _ref9 = address.find(function (item) {
            return item.types.includes('country');
          }) || {},
          _ref9$long_name = _ref9.long_name,
          country = _ref9$long_name === void 0 ? '' : _ref9$long_name,
          _ref9$short_name = _ref9.short_name,
          countryCode = _ref9$short_name === void 0 ? '' : _ref9$short_name;
        if ('address-country' in form.initialValues) {
          form.setFieldValue('address-country', country);
        }
        if ('address-country_code' in form.initialValues) {
          form.setFieldValue('address-country_code', countryCode);
        }
        if ('address-city' in form.initialValues) {
          var _address$find;
          form.setFieldValue('address-city', ((_address$find = address.find(function (address) {
            return ['locality', 'administrative_area_level_4', 'administrative_area_level_3', 'administrative_area_level_2', 'administrative_area_level_1'].some(function (type) {
              return address.types.includes(type);
            });
          })) === null || _address$find === void 0 ? void 0 : _address$find.long_name) || '');
        }
        form.setFieldValue(props.latitude ? props.latitude : 'address-latitude', result[0].geometry.location.lat());
        form.setFieldValue(props.longitude ? props.longitude : 'address-longitude', result[0].geometry.location.lng());
      });
    },
    debounce: props.debounce ? props.debounce : 300
  }, function (_ref10) {
    var getInputProps = _ref10.getInputProps,
      suggestions = _ref10.suggestions,
      getSuggestionItemProps = _ref10.getSuggestionItemProps,
      loading = _ref10.loading;
    var filteredSuggrstions = _toConsumableArray(suggestions);
    if (props.filterCountries) {
      filteredSuggrstions = filteredSuggrstions.filter(function (suggestion) {
        return suggestion.types.includes('country');
      });
    }
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(TextField, {
      name: field.name,
      label: props.label,
      type: "text",
      margin: "normal",
      fullWidth: true,
      validate: props.required ? props.validate : {},
      required: props.required ? true : false,
      inputProps: _objectSpread({}, getInputProps({
        placeholder: props.intl.formatMessage({
          id: props.placeholder ? props.placeholder : 'Entrez votre adresse ici',
          defaultMessage: props.placeholder ? props.placeholder : 'Entrez votre adresse ici'
        }),
        className: 'location-search-input',
        onBlur: function onBlur() {
          if (showError) {
            form.setFieldValue(field.name, "");
          }
        }
      })),
      style: {
        marginBottom: 0
      }
    }), filteredSuggrstions.length !== 0 && /*#__PURE__*/_react.default.createElement("div", {
      className: "autocomplete-dropdown-container",
      style: {
        border: '1px #d6d5d5 solid',
        // position: 'absolute',
        position: 'relative',
        // change from absolute because it appeared way under the field while creating in dialog
        zIndex: 99,
        backgroundColor: '#ffffff'
      }
    }, loading && /*#__PURE__*/_react.default.createElement(_core.LinearProgress, null), filteredSuggrstions.map(function (suggestion, index) {
      var className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item';
      var style = suggestion.active ? {
        backgroundColor: '#efefef',
        cursor: 'pointer'
      } : {
        backgroundColor: '#ffffff',
        cursor: 'pointer'
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        key: index
      }, /*#__PURE__*/_react.default.createElement(_core.MenuItem, _extends({}, getSuggestionItemProps(suggestion, {
        className: className,
        style: style
      }), {
        dense: true
      }), /*#__PURE__*/_react.default.createElement(_core.Icon, {
        className: "mr-4",
        style: {
          fontSize: '1rem'
        }
      }, "place"), /*#__PURE__*/_react.default.createElement("span", null, suggestion.description)), /*#__PURE__*/_react.default.createElement(_core.Divider, null));
    })));
  });
};
var WrappedAddressAutocompleteComponent = (0, _reactIntl.injectIntl)(AddressAutocompleteComponent);
var AddressAutocomplete = function AddressAutocomplete(props) {
  return /*#__PURE__*/_react.default.createElement(_formik.Field, _extends({
    component: WrappedAddressAutocompleteComponent
  }, props));
};
exports.AddressAutocomplete = AddressAutocomplete;
var PhoneComponent = function PhoneComponent(_ref11) {
  var field = _ref11.field,
    form = _ref11.form,
    props = _objectWithoutProperties(_ref11, _excluded8);
  var meta = form.getFieldMeta(field.name);
  return /*#__PURE__*/_react.default.createElement(_PhoneNumberInput.default, _extends({
    placeholder: props.placeholder,
    name: field.name,
    onChange: form.handleChange,
    value: field.value,
    required: props.required,
    errored: meta.touched && (meta.error || !_lodash.default.isEmpty(meta.error)) ? meta.error : false
  }, props));
};

// Create formik field using the phone number field component and pass props to it
var PhoneNumber = function PhoneNumber(props) {
  return /*#__PURE__*/_react.default.createElement(_formik.Field, _extends({
    component: _PhoneNumber.PhoneNumberComponent
  }, props, {
    validate: (0, _formValidators.isValidePhone)(props.required)
  }));
};

/**
 * @see: https://v4.mui.com/components/autocomplete/
 * Autocomplate wrapper by formik
 */
exports.PhoneNumber = PhoneNumber;
var AutocompleteComponent = function AutocompleteComponent(_ref12) {
  var _props$fullWidth;
  var field = _ref12.field,
    form = _ref12.form,
    props = _objectWithoutProperties(_ref12, _excluded9);
  var meta = form.getFieldMeta(field.name);
  var hasError = Boolean(meta.touched && (meta.error || !_lodash.default.isEmpty(meta.error)));
  var label = props.label,
    loading = props.loading,
    autocomplateProps = _objectWithoutProperties(props, _excluded10);
  return /*#__PURE__*/_react.default.createElement(_Autocomplete.default, _extends({
    id: field.name,
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_react.default.createElement(_TextField.default, _extends({}, params, {
        label: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
          id: label,
          defaultMessage: label
        }),
        variant: "outlined",
        error: hasError,
        helperText: hasError && meta.error,
        required: props.required,
        InputProps: _objectSpread(_objectSpread({}, params.InputProps), {}, {
          endAdornment: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, loading ? /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
            color: "inherit",
            size: 20
          }) : null, params.InputProps.endAdornment)
        })
      }));
    },
    loading: loading,
    value: field.value
  }, field, {
    fullWidth: (_props$fullWidth = props.fullWidth) !== null && _props$fullWidth !== void 0 ? _props$fullWidth : true,
    onChange: function onChange(event, value) {
      return form.setFieldValue(field.name, value);
    }
  }, autocomplateProps));
};
var Autocomplete = function Autocomplete(props) {
  return /*#__PURE__*/_react.default.createElement(_formik.Field, _extends({
    component: AutocompleteComponent
  }, props));
};
exports.Autocomplete = Autocomplete;
var LocationPicker = _LocationPicker.LocationPicker;
exports.LocationPicker = LocationPicker;
var RangeField = function RangeField(props) {
  return /*#__PURE__*/_react.default.createElement(_formik.Field, _extends({
    component: _RangeField.RangeField
  }, props));
};
exports.RangeField = RangeField;